<template>
  <div>
    <br />
    <br />
    <br />
    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" style="width:450px;" @click="jump('/empIns1')" plain>{{$t('router.empIns.empIns1')}}
          </el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-button type="primary" style="width:450px;" @click="jump('/empIns5')" plain>{{$t('router.detail.empIns5')}}
          </el-button>
        </div>
      </el-col>
    </el-row>
    <br />

    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" style="width:450px;" @click="jump('/empIns6')" plain>{{$t('router.detail.empIns6')}}
          </el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-button type="primary" style="width:450px;" @click="jump('/empIns2')" plain>{{$t('router.empIns.empIns2')}}
          </el-button>
        </div>
      </el-col>
    </el-row>
    <br />

    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" style="width:450px;" @click="jump('/empIns7')" plain>{{$t('router.detail.empIns7')}}
          </el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-button type="primary" style="width:450px;" @click="jump('/empIns8')" plain>{{$t('router.empIns.empIns8')}}
          </el-button>
        </div>
      </el-col>
    </el-row>

    <br />
    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" style="width:450px;" @click="jump('/empIns9')" plain>{{$t('router.detail.empIns9')}}
          </el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-button type="primary" style="width:450px;" @click="jump('/empIns4')" plain>{{$t('router.empIns.empIns4')}}
          </el-button>
        </div>
      </el-col>
    </el-row>
    <br />

    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" style="width:450px;" @click="jump('/empIns3')" plain>{{$t('router.empIns.empIns3')}}
          </el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-button type="primary" style="width:450px;" @click="jump('/empIns14')" plain>{{$t('router.detail.empIns14')}}
          </el-button>
        </div>
      </el-col>
    </el-row>
    <br />

    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" style="width:450px;" @click="jump('/empIns12')" plain>{{$t('router.detail.empIns12')}}
          </el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-button type="primary" style="width:450px;" @click="jump('/empIns13')" plain>{{$t('router.detail.empIns13')}}
          </el-button>
        </div>
      </el-col>
    </el-row>
    <br />
    

    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" icon="fa fa-reply" style="width:450px;" @click="jump('/homePage')" plain>&nbsp;ホームページに戻る
          </el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    jump(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpInsHome.vue